<template>
  <div class="recommend-container">
    <div class="recommend-header">
      产品推荐
    </div>
    <div class="search-row">
      <div class="recommend-material">
        <span>物料名称</span>
        <el-input placeholder="请输入物料名称"
                  v-model="productName"
                  clearable
                  size="mini"></el-input>
      </div>
      <div class="create-time">
        <span>创建时间</span>
        <el-date-picker v-model="createTime"
                        size="mini"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        @change="handleChange">
        </el-date-picker>
      </div>
      <el-button type="primary"
                 size="mini"
                 :loading="isLoading"
                 @click="handleSearch">查询</el-button>
      <el-button type="warning"
                 size="mini"
                 @click="showRecommendDialog">推荐</el-button>
    </div>
    <div class="status-row">
      <div v-for="(status, index) in statusArr"
           :key="index"
           :class="{ 'is-active': activeStatus === status }"
           @click="toggleStatus(status)">
        {{ status }}
      </div>
    </div>

    <div class="recommend-content"
         ref="main"
         v-loading="isLoading">
      <keep-alive>
        <recommended :productList="productList"
                     @getRecommendList="getRecommendList"
                     v-if="activeStatus == '已推荐'" />
        <ordered :productList="productList"
                 v-else-if="activeStatus == '已下单'" />
        <expired :productList="productList"
                 v-else-if="activeStatus == '已过期'" />
      </keep-alive>
    </div>

    <div class="pagination-wrapper">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50]"
                     :page-size="pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <el-dialog title="推荐"
               :before-close="handleDialogClose"
               :visible.sync="isShowRecommendDialog"
               width="50%">
      <el-form :model="recommendForm"
               ref="recommendFormRef"
               :rules="recommendFormRules"
               label-width="80px"
               label-position="left">
        <el-form-item label="物料名称"
                      prop="productName">
          <el-input v-model="recommendForm.productName"
                    placeholder="请输入物料名称"
                    size="mini"
                    style="width: 180px"></el-input>
        </el-form-item>
        <el-form-item label="品项"
                      prop="qualityId">
          <el-select v-model="recommendForm.qualityId"
                     placeholder="请选择品项"
                     clearable
                     size="mini"
                     style="width: 180px">
            <el-option v-for="item in qualityList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量"
                      prop="quantity"
                      required>
          <el-input-number v-model="recommendForm.quantity"
                           :precision="0"
                           :min="1"
                           size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="价格"
                      prop="price"
                      required>
          <el-input-number v-model="recommendForm.price"
                           :precision="2"
                           :min="1"
                           size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="有效期"
                      prop="priceDate">
          <el-date-picker v-model="recommendForm.priceDate"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期时间"
                          :picker-options="recommendFormPickerOptions"
                          size="mini"
                          style="width: 180px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品图片"
                      prop="uploadFiles"
                      class="pictures-item">
          <div class="addPictures">
            <el-upload action="/api/services/inquiryApp/uploadFile/PostFile"
                       list-type="picture-card"
                       :file-list="recommendForm.uploadFiles"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove"
                       :on-preview="handleUploadPreview"
                       :limit="5"
                       :on-exceed="handleUploadExceed"
                       style="width: 100px, height: 100px">
              <i class="el-icon-plus"></i>
            </el-upload>
            <p>请上传格式为jpeg、jpg或png，大小不超过5MB的图片，最多5张</p>
          </div>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="recommendForm.remark"
                    placeholder="请输入"
                    type="textarea"
                    style="width:400px;"
                    :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleRecommendCancel"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   @click="createProductRecommend"
                   size="mini">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 上传图片预览对话框 -->
    <el-dialog :visible.sync="isShowPreviewDialog">
      <img width="100%"
           :src="previewImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
// import ToAccept from '@/components/recommend/ToAccept'
// import Accepted from '@/components/recommend/Accepted'
import Recommended from '@/components/recommend/Recommended'
import Ordered from '@/components/recommend/Ordered'
import Expired from '@/components/recommend/Expired'
export default {
  components: {
    // 'to-accept': ToAccept,
    // accepted: Accepted,
    recommended: Recommended,
    ordered: Ordered,
    expired: Expired
  },
  data () {
    return {
      productName: '',
      createTime: '',
      startDate: '',
      endDate: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      isShowPreviewDialog: false,
      previewImageUrl: '',
      statusArr: ['已推荐', '已下单', '已过期'],
      activeStatus: '已推荐',
      productList: [],
      recommendForm: {
        productName: '',
        qualityId: '',
        quantity: 1,
        price: 1.0,
        priceDate: '',
        uploadFiles: [],
        remark: ''
      },
      recommendFormRules: {
        productName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        qualityId: [{ required: true, message: '请选择品项', trigger: 'blur' }],
        priceDate: [
          { required: true, message: '请选择截止日', trigger: 'blur' }
        ]
      },
      isShowRecommendDialog: false,
      qualityList: [],
      recommendFormPickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      pageSize: 10,
      currentPage: 1,
      total: 0,
      isLoading: false
    }
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/recommend')
    this.$store.commit('setAsideWidth', 150)
  },
  created () {
    this.getRecommendList()
  },
  methods: {
    async getRecommendList () {
      this.isLoading = true
      const params = {
        productName: this.productName,
        state: this.activeStatus,
        startDate: this.startDate,
        endDate: this.endDate,
        skipCount: (this.currentPage - 1) * this.pageSize,
        maxResultCount: this.pageSize
      }
      const res = await this.$http.get(
        '/api/services/inquiryApp/productRecommend/GetAll',
        params
      )
      this.productList = res.result.items
      this.total = res.result.totalCount
      this.isLoading = false
    },
    handleChange (e) {
      // 清除时间时，e为null
      if (!e) {
        this.startDate = ''
        this.endDate = ''
      } else {
        this.startDate = e[0]
        this.endDate = e[1]
      }
    },
    showRecommendDialog () {
      this.isShowRecommendDialog = true
      this.getQualityList()
    },
    getQualityList () {
      this.$http
        .get('/api/services/inquiryApp/productRecommend/GetQuality')
        .then(res => {
          this.qualityList = res.result
        })
        .catch(err => {
          this.$message.error(err.error.message)
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.getRecommendList()
    },
    toggleStatus (status) {
      this.productList = []
      this.activeStatus = status
      this.getRecommendList()
    },
    handleBeforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJpgOrPng) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJpgOrPng && isLt5M
    },
    handleUploadSuccess (response, file, fileList) {
      this.recommendForm.uploadFiles.push({
        url: file.response.result[0].sitePath,
        item: file.response.result[0]
      })
    },
    handleUploadRemove (file, fileList) {
      this.recommendForm.uploadFiles = fileList
    },
    handleUploadPreview (file) {
      this.previewImageUrl = file.url
      this.isShowPreviewDialog = true
    },
    handleUploadExceed (files, fileList) {
      this.$message.warning('最多上传5张图片')
    },
    handleRecommendCancel () {
      this.recommendForm = {
        productName: '',
        qualityId: '',
        quantity: 1,
        price: 1.0,
        priceDate: '',
        uploadFiles: [],
        remark: ''
      }
      this.isShowRecommendDialog = false
    },
    createProductRecommend () {
      this.$refs.recommendFormRef.validate(valid => {
        if (valid) {
          let uploadFiles = []
          this.recommendForm.uploadFiles.forEach(item => {
            uploadFiles.push(item.item)
          })
          this.recommendForm.uploadFiles = uploadFiles
          this.$http
            .post(
              '/api/services/inquiryApp/productRecommend/Create',
              this.recommendForm
            )
            .then(res => {
              this.$message.success('推荐成功！')
              this.getRecommendList()
              this.recommendForm = {
                productName: '',
                qualityId: '',
                quantity: 1,
                price: 1.0,
                priceDate: '',
                uploadFiles: [],
                remark: ''
              }
              this.isShowRecommendDialog = false
            })
            .catch(err => {
              console.log(err)
              this.recommendForm = {
                productName: '',
                qualityId: '',
                quantity: 1,
                price: 1.0,
                priceDate: '',
                uploadFiles: [],
                remark: ''
              }
              this.isShowRecommendDialog = false
            })
        }
      })
    },
    handleDialogClose (done) {
      this.recommendForm = {
        productName: '',
        qualityId: '',
        quantity: 1,
        price: 1.0,
        priceDate: '',
        uploadFiles: [],
        remark: ''
      }
      done()
    },
    handleSizeChange (newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getRecommendList()
    },
    handleCurrentChange (newPage) {
      this.currentPage = newPage
      this.getRecommendList()
    }
  }
}
</script>
<style lang="less" scoped>
.recommend-container {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.recommend-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.search-row {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.create-time,
.recommend-material {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 30px;
  span {
    margin-right: 15px;
    color: #2f343c;
  }
}
.recommend-material {
  width: 300px;
}
.status-row {
  height: 35px;
  display: flex;
  position: relative;
  margin-top: 15px;
  .is-active {
    border: 1px solid #027cff;
    color: #027cff;
    z-index: 5;
  }
  > div {
    height: 35px;
    padding: 0 10px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #b7bbc8;
    position: absolute;
    color: #2f343c;
    user-select: none;
    &:hover {
      border: 1px solid #027cff;
      color: #027cff;
      z-index: 5;
      cursor: pointer;
    }
    &:first-child {
      border-radius: 3px 0 0 3px;
      left: 0;
    }
    &:nth-child(2) {
      left: 63px;
    }
    &:nth-child(3) {
      border-radius: 0 3px 3px 0;
      left: 126px;
    }
  }
}
.recommend-content {
  margin-top: 15px;
  height: calc(100% - 200px);
}
.el-form-item {
  margin-bottom: 10;
  display: flex;
  align-items: center;
  /deep/ .el-form-item__content {
    margin-left: 40px !important;
  }
}
.pictures-item {
  margin-top: 10px;
  margin-bottom: 15px;
  /deep/ .el-form-item__label {
    height: 60px !important;
    line-height: 60px;
  }
}
.addPictures {
  /deep/ div {
    height: 60px;
    font-size: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    ul {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      li {
        margin-bottom: 0;
        .el-upload-list__item-status-label {
          display: none;
        }
        .el-upload-list__item-actions {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          font-size: 15px;
        }
      }
    }
  }
  /deep/ .el-upload-list__item-delete {
    margin-left: 0;
  }
  /deep/ .el-upload--picture-card {
    width: 60px !important;
    height: 60px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 60px !important;
    height: 60px !important;
  }
}
.pagination-wrapper {
  padding-top: 20px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
